var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chats-container",class:[_vm.size ? 'chats-container--' + _vm.size : '', _vm.addBottomClass ? 'chats-container--bottom' : '']},[_c('ChatsBtn',{attrs:{"size":_vm.size}}),_c('ChatsList',{attrs:{"size":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }